// Popover forwards no aria-label to its button, so visually hidden text names it.
export const labelledTriggerProps = (label) =>
  label
    ? {
        text: <span className="sr-only">{label}</span>,
        tooltip: label,
        iconClassName: '!mr-0',
        buttonClassName: '!px-0 focus-visible:ring-2 focus-visible:ring-primary-300'
      }
    : {};
